import React, { Component } from 'react';
import '../myutils';
import {
  translate,
} from 'react-admin';
import BookIcon from '@material-ui/icons/Book';
import Download from '@material-ui/icons/FileDownload';
import { configAPI } from '../config'
import { push as pushAction } from 'react-router-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
export const TemplateIcon = BookIcon;

class DownloadFile extends Component {

  state = {
    open: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      record: false
    }

  }

  handleClickDownload = (e, record) => {
    e.stopPropagation();
    this.props.handleCloseMenu();

    return fetch(configAPI.api.prod + '/DownloadFile?token=' + sessionStorage.B.encodeDecode() + '&path=' + record.what, {
      method: "POST",
      headers: new Headers({
        'Content-Type': 'application/binary',
        'Content-Disposition': 'attachment'
      })
    });

  }
  
  render() {
    const { translate, record } = this.props;
    var filename = record.what.substring(record.what.lastIndexOf("/") + 1);

    return (
      <Tooltip title={translate(`trans.Download`)}>
        <IconButton onClick={(e) => this.handleClickDownload(e, record)}>
          <a href={configAPI.api.prod + '/DownloadFile?token=' + sessionStorage.B.encodeDecode() + '&path=' + record.what} download={filename} style={{ color: 'gray' }}>
            <Download />
          </a>
        </IconButton>
      </Tooltip>
    );
  }
}

DownloadFile.propTypes = {
  push: PropTypes.func,
  record: PropTypes.object,
  showNotification: PropTypes.func,
};

export default connect(null, {
  push: pushAction,
})(translate(DownloadFile));
